var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-page',[(!_vm.sent)?_c('forgot-password-form',{attrs:{"email-initial":_vm.email},on:{"sent":function($event){_vm.sent = true}}}):_c('forgot-password-email-sent-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }